import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PageHeader({ title, description, actions, breadcrumb, backTo }) {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col gap-4 pb-4 sm:flex-row sm:items-end sm:justify-between">
            <div className="space-y-1.5">
                {breadcrumb && (
                    <nav className="flex items-center gap-1 text-xs text-muted-foreground">
                        {breadcrumb.map((b, i) => (
                            <React.Fragment key={`${b.to || b.label}-${i}`}>
                                {b.to ? (
                                    <Link to={b.to} className="hover:text-foreground">
                                        {b.label}
                                    </Link>
                                ) : (
                                    <span>{b.label}</span>
                                )}
                                {i < breadcrumb.length - 1 && <span className="opacity-60">/</span>}
                            </React.Fragment>
                        ))}
                    </nav>
                )}
                <div className="flex items-center gap-2">
                    {backTo && (
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => navigate(backTo)}
                            aria-label="Voltar"
                            data-testid="page-header-back"
                        >
                            <ChevronLeft className="h-5 w-5" />
                        </Button>
                    )}
                    <h1 className="text-xl font-semibold tracking-tight sm:text-2xl" data-testid="page-title">
                        {title}
                    </h1>
                </div>
                {description && (
                    <p className="text-sm text-muted-foreground">{description}</p>
                )}
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
    );
}
